import './MainNav.scss';

import React from 'react';
import classNames from 'classnames';

import Icon from 'components/Icon';
import MainNavLink from './MainNavLink';

export default class MainNav extends React.Component {

    static propTypes = {
        pathname: React.PropTypes.string.isRequired

    };

    constructor(props) {
        super(props);
        this.links = [
            {
                link: '/assignments',
                text: 'Assignments',
                icon: 'assignments',
                activeLinks: [
                    '/assignments'
                ]
            }, {
                link: '/content',
                text: 'Content',
                icon: 'content',
                activeLinks: [
                    '/content'
                ]
            }, {
                link: '/users/individuals',
                text: 'Users',
                icon: 'users',
                activeLinks: [
                    '/users',
                    '/users/individuals',
                    '/users/groups'
                ]
            }, {
                link: '/pinpoints',
                text: 'PinPoints',
                icon: 'pinpoints',
                activeLinks: [
                    '/pinpoints'
                ]
            }, {
                link: '/reports',
                text: 'Reports',
                icon: 'reports',
                activeLinks: [
                    '/reports'
                ]
            }
        ];
    }

    render() {
        return (
            <nav className="main-nav">
                {this.links.map((link, index) => {
                    return (
                        <MainNavLink to={link.link}
                                     key={index}
                                     className={classNames('main-nav__item', {'active': link.activeLinks.indexOf(this.props.pathname) > -1 })}
                                     onClick={document.body.classList.remove('open-menu')}>
                            <Icon icon={link.icon} />
                        </MainNavLink>
                    )
                })}
                <MainNavLink to="/logout"
                             className="main-nav__item logout-link"
                             onClick={document.body.classList.remove('open-menu')}>
                    <Icon icon="logout" />
                </MainNavLink>
                <div role="button"
                     className="main-nav__close"
                     onClick={() => {document.body.classList.remove('open-menu')}}>
                </div>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MainNav/index.js